<div class="container">

  <div class="row">
    <section [class]="fold ? 'tableFold' : 'tableUnfold'">
      <mat-card appearance="outlined" class="content">
        <div class="table-container" [fxShow]="dataSource.data.length">
          <table mat-table [dataSource]="dataSource" id="table" class="table" matSort matSortActive="pageNumber" matSortStart="asc"
            [trackBy]="trackById">

            <ng-container matColumnDef="number">
              <th mat-header-cell *matHeaderCellDef>{{ 'number' | translate }}</th>
              <td mat-cell *matCellDef="let index">
                <span [matTooltip]="index.pageNumber">{{ index.pageNumber }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="title">
              <th mat-header-cell *matHeaderCellDef>{{ 'title' | translate }}</th>
              <td mat-cell *matCellDef="let index">
                <span [matTooltip]="index.name">{{ index.name }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef>{{ 'type' | translate }}</th>
              <td mat-cell *matCellDef="let index">
                <mat-icon matTooltip="{{getTypeDescription(index.pageType)}}">{{getTypeIcon(index.pageType)}}</mat-icon>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
            <tr mat-row class="selectable" *matRowDef="let row; columns: tableColumns;" (click)="showPreview($event, row)"></tr>
          </table>
          <mat-paginator class="mat-paginator-sticky" [pageSize]="10000" [pageSizeOptions]="pageSizeOptions"
          [hidePageSize]="true" [length]="totalCount" [showFirstLastButtons]="true" (page)="pageChange($event)"></mat-paginator>
        </div>
        @if (!dataSource.data.length && !loading) {
          <saf-empty-message (reloadClicked)="reloadTable()"></saf-empty-message>
        }
      </mat-card>
    </section>

    <div class="foldButton" (click)="foldTable()">
      @if (!fold) {
        <mat-icon>chevron_left</mat-icon>
      }
      @if (fold) {
        <mat-icon>chevron_right</mat-icon>
      }
    </div>

    <section [class]="fold ? 'viewFold' : 'viewUnfold'">
      <mat-card appearance="outlined" class="contentBox">
        <saf-schooling-index-content [indexId]="lastIndexId"></saf-schooling-index-content>
      </mat-card>
    </section>

  </div>

  @if (!tuitionId) {
    <div class="buttons">
      <button mat-raised-button (click)="back()" disabled="{{pageNumber <= 1}}">
        <div class="buttonContent">
          <mat-icon>arrow_back</mat-icon>
          <p>{{ 'back' | translate }}</p>
        </div>
      </button>
      <button mat-raised-button (click)="next()" disabled="{{pageNumber === dataSource.data.length}}">
        <div class="buttonContent">
          <p>{{ 'next' | translate }}</p>
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </button>
    </div>
  }

  @if (tuitionId) {
    <div class="buttons">
      <button mat-raised-button (click)="back()" disabled="{{pageNumber <= 1}}">
        <div class="buttonContent">
          <mat-icon>arrow_back</mat-icon>
          <p>{{ 'back' | translate }}</p>
        </div>
      </button>
      @if (pageNumber !== dataSource.data.length) {
        <button mat-raised-button (click)="next()" disabled="{{pageNumber === dataSource.data.length}}">
          <div class="buttonContent">
            <p>{{ 'next' | translate }}</p>
            <mat-icon>arrow_forward</mat-icon>
          </div>
        </button>
      }
      @if (pageNumber === dataSource.data.length) {
        <button mat-raised-button (click)="ready()">
          <div class="buttonContent">
            <p>{{ 'ready' | translate }}</p>
            <mat-icon>check</mat-icon>
          </div>
        </button>
      }
    </div>
  }
</div>
